export default "__VITE_ASSET__DOyLNt4x__"